package com.klantenstop.web.pages.authentication.companyRegistration

import com.klantenstop.web.components.form.RegisterFormData
import com.klantenstop.web.components.form.RequestCompanyAccessFormData
//import com.klantenstop.web.data.models.domain.CompanyNumberCheck
import com.klantenstop.web.utils.MVI

interface CompanyRegistrationContract : MVI<CompanyRegistrationContract.State, CompanyRegistrationContract.Intent, CompanyRegistrationContract.Effect> {
    data class State(
        val companyNumber: String = "",
        val isCompanyNumberValid: Boolean? = null,
        val showCompanyNumberError: String? = null,
//        val companyCheckResponse: CompanyNumberCheck? = null,
        val formData: RegisterFormData? = null,
        val requestAccessFormData: RequestCompanyAccessFormData? = null,
        val showValidation: Boolean = false
    )

    sealed class Intent {
        data object CompanyRegistration : Intent()
        data class UpdateCompanyNumber(val value: String) : Intent()
        data class ValidateCompanyNumber(val companyNumber: String) : Intent()
        data object CheckValidityOfCompanyNumber : Intent()
        data object Reset : Intent()
        data object RequestAccess : Intent()
        data class UpdateFormData(val formData: RegisterFormData) : Intent()
        data class UpdateRequestAccessFormData(val formData: RequestCompanyAccessFormData) : Intent()
    }

    sealed class Effect {
        data object NavigateToNextScreen : Effect()
    }
}
